import { render, staticRenderFns } from "./AllArticle.vue?vue&type=template&id=152192a9&scoped=true&"
import script from "./AllArticle.vue?vue&type=script&lang=js&"
export * from "./AllArticle.vue?vue&type=script&lang=js&"
import style0 from "./AllArticle.vue?vue&type=style&index=0&id=152192a9&prod&lang=scss&scoped=true&"
import style1 from "./AllArticle.vue?vue&type=style&index=1&id=152192a9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152192a9",
  null
  
)

export default component.exports